// External dependencies.
import $ from "jquery";
import { hasQueryArg } from "@wordpress/url";
import domReady from "@wordpress/dom-ready";

( function () {
    domReady( function () {
        const { is_faq_archive } = window.app;

        if ( "1" === is_faq_archive && hasQueryArg( window.location.href, 'shipping-costs' ) ) {
            window.scrollTo( {
                top: document.body.scrollHeight,
                left: 0,
                behavior: 'smooth',
            } );

            $( '#faqs-accordion > .card:last-child > .collapse' ).collapse( 'show' );
        }
    } );
} )();
